/**
 * Transcript timing helpers shared across platform packages.
 *
 * Segment and sentence boundaries arrive as `string | number`: either a plain
 * seconds value or an `HH:MM:SS.mmm` timecode. `parseFloat` on the timecode
 * form yields the leading hour field (0 for almost every segment), so parsing
 * has to be explicit.
 */

/** Parse `HH:MM:SS.mmm`, `H:MM:SS` or `MM:SS` to seconds. */
export function timestampToSeconds(ts: string): number {
  try {
    const [timePart, msPart] = ts.split(".");
    const parts = timePart.split(":").map(Number);
    let secs = 0;
    if (parts.length === 3) secs = parts[0] * 3600 + parts[1] * 60 + parts[2];
    else if (parts.length === 2) secs = parts[0] * 60 + parts[1];
    else secs = parts[0];
    if (msPart) secs += parseInt(msPart.padEnd(3, "0")) / 1000;
    return isNaN(secs) ? 0 : secs;
  } catch {
    return 0;
  }
}

/** Seconds for either boundary form. Unparseable input is 0, never NaN. */
export function toSeconds(value: string | number | null | undefined): number {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (!value) return 0;
  return timestampToSeconds(value);
}
